import { legoInit, legoPerf } from '@zz-common/lego'

import 'core-js/stable'
import 'regenerator-runtime/runtime'
import VueLazyLoad from 'vue-lazyload'
import { Select, Option } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'animate.css';
import './flexible.js'
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import loadingPlaceholder from '@/assets/loading-placeholder.png'
Vue.config.productionTip = false
Vue.use(Select)
Vue.use(Option)

class __App__ {
  init() {
    tryCatch(() => {
      // 全局初始化乐高埋点的值，默认合入backup
      legoInit()
      legoPerf()
    })
    // 懒加载
    this.sueLazyLoad()
    // 注册vue实例
    this.mount()
  }

  mount() {
    new Vue({
      router,
      store,
      render: (h) => h(App)
    }).$mount('#app')
  }

  sueLazyLoad() {
    tryCatch(function() {
      Vue.use(VueLazyLoad, {
        preLoad: 1.3,
        try: 2,
        error: loadingPlaceholder,
        loading: loadingPlaceholder
      })
    })
  }
}
const app = new __App__()
app.init()

function tryCatch(fn) {
  try {
    fn()
  } catch (err) {
    console.error(err)
  }
}
